<template>
  <v-dialog :value="open" width="60rem" persistent scrollable>
    <v-card>
      <v-card-title>
        <v-container fluid grid-list-lg class="pa-0" :style="{ width: '100% !important' }">
          <v-layout>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-btn icon @click="handleCloseButtonClick">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-xl :style="{ width: '100% !important' }">
          <v-layout align-center wrap>
            <v-flex :xs12="$vuetify.breakpoint.mdAndDown" shrink>
              <v-avatar :size="128">
                <img :src="avatar" alt="User avatar" :style="{ objectFit: 'cover' }" />
              </v-avatar>
            </v-flex>
            <v-flex :xs12="$vuetify.breakpoint.mdAndDown">
              <div class="title mb-3">{{ username }}</div>
              <div class="body-1">Page: {{ page }}</div>
              <div class="body-1">Channel: {{ channel }}</div>
            </v-flex>
          </v-layout>
        </v-container>
        <div v-if="$slots.default" :key="timestamp">
          <slot></slot>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    pageid: {
      type: String,
      default: ''
    },
    userid: {
      type: String,
      default: ''
    },
    pageName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timestamp: null,
      username: '',
      avatar: '',
      page: '',
      channel: ''
    }
  },
  watch: {
    open(value) {
      if (!value) return
      this.timestamp = new Date().getTime()
      this.getUsersdata(this.userid, this.pageid).then((data) => {
        this.username = data.first_name + ' ' + data.last_name
        this.avatar = data.profile_pic
        this.page = this.pageName
        this.channel = data.app
        this.$emit('handleGetUser', data)
      })
    }
  },
  methods: {
    handleCloseButtonClick() {
      this.$emit('update:open', false)
    },
    getUsersdata: function (userid, pageid) {
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: pageid
        }

        api.getUsersdata(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/UserDialog.vue